module.exports = __webpack_public_path__ + "img/favorite-tacos-charity.ef840649.png";